import { Big } from 'big.js';

// Name exported as BigDecimal to avoid confusing as to what Big is pointing to
type BigDecimal = Big;

function parseNumericValue(
  value: string | undefined | null | number,
  precision = 2
): Big {
  if (value === undefined || value === null) {
    return Big('0');
  }

  // If the value is already a number, return it
  if (typeof value === 'number') {
    return Big(value);
  }

  // Handle very specific cases where we have a string containing both a comma and a dot
  const stringVal = `${value}`;
  if (/^\d{1,3}(,\d{3})+(\.\d+)$/.test(stringVal)) {
    // US format: e.g., 1,234,567.89
    return Big(stringVal.replace(/,/g, ''));
  } else if (/^\d{1,3}(\.\d{3})+(,\d+)$/.test(stringVal)) {
    // European format: e.g., 1.234.567,89
    return Big(stringVal.replace(/\./g, '').replace(',', '.'));
  }

  const sanitizedNumber = stringVal
    .replace(/(\d),(?=\d{3}(\D|$))/g, '$1')
    .replace(/(\d)\.(?=\d{3}(\D|$))/g, '$1')
    .replace(`/(d),(?!d{${precision}(D|$))/g`, '$1.')
    .replace(/,/g, '.');
  return Big(sanitizedNumber);
}

function isNumericValue(value: string | undefined | null | number): boolean {
  if (
    value === undefined ||
    value === null ||
    (typeof value === 'number' && Number.isNaN(value))
  ) {
    return false;
  }
  try {
    return parseNumericValue(value).toString() !== 'NaN';
  } catch (_e) {
    return false;
  }
}

export { BigDecimal, isNumericValue, parseNumericValue };
